import { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { FileTypes, useProjectExportPointcloudMutation } from '../../types/graphqlTypes';
import { AppliedFilters } from './useAppliedFilters';
import { DATA_DEPTH } from '../../potree/pointCloudHelpers';

export interface ExportPointCloudOptions {
  pointCloudId: string;
  fileType: FileTypes;
  filters?: AppliedFilters;
}

export const useExportPointCloud = () => {
  const { projectId = '' } = useParams();
  const [exportPointcloudMutation, { loading }] = useProjectExportPointcloudMutation();

  const exportPointCloud = useCallback(
    async ({ pointCloudId, fileType, filters }: ExportPointCloudOptions) => {
      if (!projectId || !pointCloudId) return;

      await exportPointcloudMutation({
        variables: {
          projectId,
          pointCloudId,
          fileType,
          classificationFilters: filters?.classifications?.length ? filters.classifications.map((cl) => +cl.code) : undefined,
          ...(filters?.heightFilter && {
            heightFilters: [filters.heightFilter.min, filters.heightFilter.max],
          }),
          ...(filters?.intensityFilter && {
            intensityFilters: [filters.intensityFilter.min, filters.intensityFilter.max],
          }),
          ...(filters?.resolutionFilter && {
            resolutionFilter: filters.resolutionFilter.resolutionLevel + DATA_DEPTH,
          }),
          ...(filters?.clippingFilter && {
            clippingFilter: filters.clippingFilter.nrOfClippingBoxes + filters.clippingFilter.nrOfClippingClusters,
          }),
        },
      });
    },
    [projectId, exportPointcloudMutation],
  );

  return { exportPointCloud, loading };
};
